import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import useWindowDimensions from "../../_helpers/dimensions";
import "./slider.css";
import { europe } from "../../_helpers/places";

export const SliderCarousel = ({ data, continent }) => {


        const [currentIndx, setCurrentIndx] = useState(0);
        const [slideWidth, setSlideWidth] = useState(600);

        const imageCnt = data.length;
    
        const incrementIndx = () => {
            if (currentIndx === imageCnt - 1) return;
            setCurrentIndx((i) => i + 1)
        }
    
        const decrementIndx = () => {
            if (currentIndx === 0) return;
            setCurrentIndx((i) => i - 1)
        }
        
        const { width } = useWindowDimensions();
    
        useEffect(() => {
            width < 450 ? setSlideWidth(width) : setSlideWidth(600);
        },[width]);
    

  return (
    <div className="carousel-container">
        <div className="slide-pic-container">
        
            {data.map((imageUri,indx) => (
                <div className="box"
                    style={{
                        transform: `translateX(${-slideWidth * currentIndx}px)`,
                        transition: 'transform 1.2s ease'
                    }}
                >
                
                
                <img 
                    src={imageUri} 
                    alt="" 
                    key={indx} 
                    className="slide-pic"
                />
                </div>
            ))}

        </div>
        <div className="prev-next-box">
            <button className="prev-next-btn" onClick={incrementIndx}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className="ctry-name">{continent[currentIndx]}</div>
            <button className="prev-next-btn" onClick={decrementIndx}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
        <div className="slide-indicator">
            {data.map((_,indx) => {
                return (
                    <div 
                        className={classNames(
                            'dot',
                            {'current': currentIndx === indx }
                        )} 
                        key={indx}
                    />
                )
            })}
        </div>
        <div className="prev-box">
            {data.map((pic,key) => {
                return( 
                    <img
                        src={pic}
                        alt=""
                        width={100}
                        height={70}
                        className={classNames("prev-sm",{'curr': currentIndx === key})}
                        key={key}
                        onClick={() => setCurrentIndx(key)}
                        style={{
                            transform: `translateX(${-100 * currentIndx}px)`,
                            transition: 'transform 1.2s ease'
                        }}
                    />
                )
            })}
        </div>
    </div>
  )
}